import { DYNAMIC_FIELD_TYPES, VIEW_ONLY_QUERY_PARAM } from "../common/constants";

export const dynamicTableTooltips = {
    name: "The name of this dynamic table.",
    description: "A description for this dynamic table.",
    type: "Select the table's scope: Global, Client, or Project level.",
    client_id: "Make this table available to the chosen client.",
    project_id: "Make this table available to the selected project.",
    entity_types: "Choose which FCA records this table's rows can be linked to.",
    published: "Publish this table to show its records under Client Dynamic Tables.",
    band_id: "Choose the band this field is grouped under on the record form.",
    notes: "Internal notes about this field, for the team maintaining the table.",
    field_mode:
        "Choose how this field works: 'Input' means users enter the value directly; 'Calculated' means it's auto-computed from other fields.",
    apply_option_color: "Show each option's colour behind its value in the record tables."
};

const ENTITY_TYPE_LABELS = {
    recommendation: "Recommendation",
    asset: "Asset",
    building: "Building",
    site: "Site",
    region: "Region",
    project: "Project"
};

// Recommendation, asset and project have no host tab yet; they stay in the label map so tables already linked to them
// still read correctly.
export const ENTITY_TYPE_OPTIONS = ["region", "site", "building"].map(value => ({ value, label: ENTITY_TYPE_LABELS[value] }));

export const getEntityTypeLabel = value => ENTITY_TYPE_LABELS[value] || value;

export const RECORD_DETAILS_TAB = "details";

export const RECORD_LINKED_ENTITIES_TAB = "linkedEntities";

const ENTITY_INFO_PATHS = {
    site: id => `/site/siteinfo/${id}/basicdetails`,
    region: id => `/region/regioninfo/${id}/basicdetails`,
    building: id => `/building/buildinginfo/${id}/basicdetails`,
    project: id => `/project/projectinfo/${id}/basicdetails`,
    asset: id => `/assets/assetInfo/${id}/basicdetails`
};

const ENTITY_VIEW_PERMISSIONS = { site: "sites", region: "regions", building: "buildings", project: "fca_projects", asset: "assets" };

export const getEntityInfoPath = (entityType, entityId) => {
    const path = entityId ? ENTITY_INFO_PATHS[entityType]?.(entityId) : undefined;
    return path ? `${path}?${VIEW_ONLY_QUERY_PARAM}=true` : path;
};

export const getEntityPermissionKey = entityType => ENTITY_VIEW_PERMISSIONS[entityType];

export const CLIENT_DYNAMIC_TABLES_TAB = "clientDynamicTables";

export const CLIENT_DYNAMIC_TABLES_PATH = "/client-dynamic-tables";

export const getRecordsBasePath = tableId => `/dynamic-tables/info/${tableId}/dynamictablerecords`;

export const normalizeFieldKey = value =>
    (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");

export const GET_DYNAMIC_TABLES_REQUEST = "GET_DYNAMIC_TABLES_REQUEST";
export const GET_DYNAMIC_TABLES_SUCCESS = "GET_DYNAMIC_TABLES_SUCCESS";
export const GET_DYNAMIC_TABLES_FAILURE = "GET_DYNAMIC_TABLES_FAILURE";

export const GET_PUBLISHED_DYNAMIC_TABLES_REQUEST = "GET_PUBLISHED_DYNAMIC_TABLES_REQUEST";
export const GET_PUBLISHED_DYNAMIC_TABLES_SUCCESS = "GET_PUBLISHED_DYNAMIC_TABLES_SUCCESS";
export const GET_PUBLISHED_DYNAMIC_TABLES_FAILURE = "GET_PUBLISHED_DYNAMIC_TABLES_FAILURE";

export const GET_DYNAMIC_TABLE_BY_ID_REQUEST = "GET_DYNAMIC_TABLE_BY_ID_REQUEST";
export const GET_DYNAMIC_TABLE_BY_ID_SUCCESS = "GET_DYNAMIC_TABLE_BY_ID_SUCCESS";
export const GET_DYNAMIC_TABLE_BY_ID_FAILURE = "GET_DYNAMIC_TABLE_BY_ID_FAILURE";

export const ADD_DYNAMIC_TABLE_REQUEST = "ADD_DYNAMIC_TABLE_REQUEST";
export const ADD_DYNAMIC_TABLE_SUCCESS = "ADD_DYNAMIC_TABLE_SUCCESS";
export const ADD_DYNAMIC_TABLE_FAILURE = "ADD_DYNAMIC_TABLE_FAILURE";

export const UPDATE_DYNAMIC_TABLE_REQUEST = "UPDATE_DYNAMIC_TABLE_REQUEST";
export const UPDATE_DYNAMIC_TABLE_SUCCESS = "UPDATE_DYNAMIC_TABLE_SUCCESS";
export const UPDATE_DYNAMIC_TABLE_FAILURE = "UPDATE_DYNAMIC_TABLE_FAILURE";

export const DELETE_DYNAMIC_TABLE_REQUEST = "DELETE_DYNAMIC_TABLE_REQUEST";
export const DELETE_DYNAMIC_TABLE_SUCCESS = "DELETE_DYNAMIC_TABLE_SUCCESS";
export const DELETE_DYNAMIC_TABLE_FAILURE = "DELETE_DYNAMIC_TABLE_FAILURE";

export const GET_LIST_FOR_DYNAMIC_TABLE_FILTER_REQUEST = "GET_LIST_FOR_DYNAMIC_TABLE_FILTER_REQUEST";
export const GET_LIST_FOR_DYNAMIC_TABLE_FILTER_SUCCESS = "GET_LIST_FOR_DYNAMIC_TABLE_FILTER_SUCCESS";
export const GET_LIST_FOR_DYNAMIC_TABLE_FILTER_FAILURE = "GET_LIST_FOR_DYNAMIC_TABLE_FILTER_FAILURE";

export const UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_SUCCESS = "UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_FAILURE = "UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_FAILURE";

export const CLEAR_DYNAMIC_TABLE_ENTITY_PARAMS = "CLEAR_DYNAMIC_TABLE_ENTITY_PARAMS";

export const CLEAR_DYNAMIC_TABLE_RESPONSES = "CLEAR_DYNAMIC_TABLE_RESPONSES";

export const GET_DYNAMIC_TABLE_BANDS_REQUEST = "GET_DYNAMIC_TABLE_BANDS_REQUEST";
export const GET_DYNAMIC_TABLE_BANDS_SUCCESS = "GET_DYNAMIC_TABLE_BANDS_SUCCESS";
export const GET_DYNAMIC_TABLE_BANDS_FAILURE = "GET_DYNAMIC_TABLE_BANDS_FAILURE";

export const ADD_DYNAMIC_TABLE_BAND_REQUEST = "ADD_DYNAMIC_TABLE_BAND_REQUEST";
export const ADD_DYNAMIC_TABLE_BAND_SUCCESS = "ADD_DYNAMIC_TABLE_BAND_SUCCESS";
export const ADD_DYNAMIC_TABLE_BAND_FAILURE = "ADD_DYNAMIC_TABLE_BAND_FAILURE";

export const UPDATE_DYNAMIC_TABLE_BAND_REQUEST = "UPDATE_DYNAMIC_TABLE_BAND_REQUEST";
export const UPDATE_DYNAMIC_TABLE_BAND_SUCCESS = "UPDATE_DYNAMIC_TABLE_BAND_SUCCESS";
export const UPDATE_DYNAMIC_TABLE_BAND_FAILURE = "UPDATE_DYNAMIC_TABLE_BAND_FAILURE";

export const DELETE_DYNAMIC_TABLE_BAND_REQUEST = "DELETE_DYNAMIC_TABLE_BAND_REQUEST";
export const DELETE_DYNAMIC_TABLE_BAND_SUCCESS = "DELETE_DYNAMIC_TABLE_BAND_SUCCESS";
export const DELETE_DYNAMIC_TABLE_BAND_FAILURE = "DELETE_DYNAMIC_TABLE_BAND_FAILURE";

export const GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_REQUEST = "GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_REQUEST";
export const GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_SUCCESS = "GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_SUCCESS";
export const GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_FAILURE = "GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_FAILURE";

export const GET_DYNAMIC_TABLE_FIELDS_REQUEST = "GET_DYNAMIC_TABLE_FIELDS_REQUEST";
export const GET_DYNAMIC_TABLE_FIELDS_SUCCESS = "GET_DYNAMIC_TABLE_FIELDS_SUCCESS";
export const GET_DYNAMIC_TABLE_FIELDS_FAILURE = "GET_DYNAMIC_TABLE_FIELDS_FAILURE";

export const GET_DYNAMIC_TABLE_FIELDS_GROUPED_REQUEST = "GET_DYNAMIC_TABLE_FIELDS_GROUPED_REQUEST";
export const GET_DYNAMIC_TABLE_FIELDS_GROUPED_SUCCESS = "GET_DYNAMIC_TABLE_FIELDS_GROUPED_SUCCESS";
export const GET_DYNAMIC_TABLE_FIELDS_GROUPED_FAILURE = "GET_DYNAMIC_TABLE_FIELDS_GROUPED_FAILURE";

export const GET_DYNAMIC_TABLE_FIELD_BY_ID_REQUEST = "GET_DYNAMIC_TABLE_FIELD_BY_ID_REQUEST";
export const GET_DYNAMIC_TABLE_FIELD_BY_ID_SUCCESS = "GET_DYNAMIC_TABLE_FIELD_BY_ID_SUCCESS";
export const GET_DYNAMIC_TABLE_FIELD_BY_ID_FAILURE = "GET_DYNAMIC_TABLE_FIELD_BY_ID_FAILURE";

export const ADD_DYNAMIC_TABLE_FIELD_REQUEST = "ADD_DYNAMIC_TABLE_FIELD_REQUEST";
export const ADD_DYNAMIC_TABLE_FIELD_SUCCESS = "ADD_DYNAMIC_TABLE_FIELD_SUCCESS";
export const ADD_DYNAMIC_TABLE_FIELD_FAILURE = "ADD_DYNAMIC_TABLE_FIELD_FAILURE";

export const UPDATE_DYNAMIC_TABLE_FIELD_REQUEST = "UPDATE_DYNAMIC_TABLE_FIELD_REQUEST";
export const UPDATE_DYNAMIC_TABLE_FIELD_SUCCESS = "UPDATE_DYNAMIC_TABLE_FIELD_SUCCESS";
export const UPDATE_DYNAMIC_TABLE_FIELD_FAILURE = "UPDATE_DYNAMIC_TABLE_FIELD_FAILURE";

export const DELETE_DYNAMIC_TABLE_FIELD_REQUEST = "DELETE_DYNAMIC_TABLE_FIELD_REQUEST";
export const DELETE_DYNAMIC_TABLE_FIELD_SUCCESS = "DELETE_DYNAMIC_TABLE_FIELD_SUCCESS";
export const DELETE_DYNAMIC_TABLE_FIELD_FAILURE = "DELETE_DYNAMIC_TABLE_FIELD_FAILURE";

export const REORDER_DYNAMIC_TABLE_FIELDS_REQUEST = "REORDER_DYNAMIC_TABLE_FIELDS_REQUEST";
export const REORDER_DYNAMIC_TABLE_FIELDS_SUCCESS = "REORDER_DYNAMIC_TABLE_FIELDS_SUCCESS";
export const REORDER_DYNAMIC_TABLE_FIELDS_FAILURE = "REORDER_DYNAMIC_TABLE_FIELDS_FAILURE";

export const GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_REQUEST = "GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_REQUEST";
export const GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_SUCCESS = "GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_SUCCESS";
export const GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_FAILURE = "GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_FAILURE";

export const GET_DYNAMIC_TABLE_RECORDS_REQUEST = "GET_DYNAMIC_TABLE_RECORDS_REQUEST";
export const GET_DYNAMIC_TABLE_RECORDS_SUCCESS = "GET_DYNAMIC_TABLE_RECORDS_SUCCESS";
export const GET_DYNAMIC_TABLE_RECORDS_FAILURE = "GET_DYNAMIC_TABLE_RECORDS_FAILURE";

export const GET_LIST_FOR_LINKED_ENTITY_FILTER_REQUEST = "GET_LIST_FOR_LINKED_ENTITY_FILTER_REQUEST";
export const GET_LIST_FOR_LINKED_ENTITY_FILTER_SUCCESS = "GET_LIST_FOR_LINKED_ENTITY_FILTER_SUCCESS";
export const GET_LIST_FOR_LINKED_ENTITY_FILTER_FAILURE = "GET_LIST_FOR_LINKED_ENTITY_FILTER_FAILURE";

export const GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_REQUEST = "GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_REQUEST";
export const GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_SUCCESS = "GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_SUCCESS";
export const GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_FAILURE = "GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_FAILURE";

export const GET_DYNAMIC_TABLE_RECORD_TOTALS_REQUEST = "GET_DYNAMIC_TABLE_RECORD_TOTALS_REQUEST";
export const GET_DYNAMIC_TABLE_RECORD_TOTALS_SUCCESS = "GET_DYNAMIC_TABLE_RECORD_TOTALS_SUCCESS";
export const GET_DYNAMIC_TABLE_RECORD_TOTALS_FAILURE = "GET_DYNAMIC_TABLE_RECORD_TOTALS_FAILURE";

export const GET_DYNAMIC_TABLE_RECORD_BY_ID_REQUEST = "GET_DYNAMIC_TABLE_RECORD_BY_ID_REQUEST";
export const GET_DYNAMIC_TABLE_RECORD_BY_ID_SUCCESS = "GET_DYNAMIC_TABLE_RECORD_BY_ID_SUCCESS";
export const GET_DYNAMIC_TABLE_RECORD_BY_ID_FAILURE = "GET_DYNAMIC_TABLE_RECORD_BY_ID_FAILURE";

export const ADD_DYNAMIC_TABLE_RECORD_REQUEST = "ADD_DYNAMIC_TABLE_RECORD_REQUEST";
export const ADD_DYNAMIC_TABLE_RECORD_SUCCESS = "ADD_DYNAMIC_TABLE_RECORD_SUCCESS";
export const ADD_DYNAMIC_TABLE_RECORD_FAILURE = "ADD_DYNAMIC_TABLE_RECORD_FAILURE";

export const UPDATE_DYNAMIC_TABLE_RECORD_REQUEST = "UPDATE_DYNAMIC_TABLE_RECORD_REQUEST";
export const UPDATE_DYNAMIC_TABLE_RECORD_SUCCESS = "UPDATE_DYNAMIC_TABLE_RECORD_SUCCESS";
export const UPDATE_DYNAMIC_TABLE_RECORD_FAILURE = "UPDATE_DYNAMIC_TABLE_RECORD_FAILURE";

export const DELETE_DYNAMIC_TABLE_RECORD_REQUEST = "DELETE_DYNAMIC_TABLE_RECORD_REQUEST";
export const DELETE_DYNAMIC_TABLE_RECORD_SUCCESS = "DELETE_DYNAMIC_TABLE_RECORD_SUCCESS";
export const DELETE_DYNAMIC_TABLE_RECORD_FAILURE = "DELETE_DYNAMIC_TABLE_RECORD_FAILURE";

export const GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_REQUEST = "GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_REQUEST";
export const GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_SUCCESS = "GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_SUCCESS";
export const GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_FAILURE = "GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_FAILURE";
export const RESET_DYNAMIC_TABLE_RECORD_COMMON_DATA = "RESET_DYNAMIC_TABLE_RECORD_COMMON_DATA";

export const BULK_EDIT_DYNAMIC_TABLE_RECORDS_REQUEST = "BULK_EDIT_DYNAMIC_TABLE_RECORDS_REQUEST";
export const BULK_EDIT_DYNAMIC_TABLE_RECORDS_SUCCESS = "BULK_EDIT_DYNAMIC_TABLE_RECORDS_SUCCESS";
export const BULK_EDIT_DYNAMIC_TABLE_RECORDS_FAILURE = "BULK_EDIT_DYNAMIC_TABLE_RECORDS_FAILURE";

export const BULK_DELETE_DYNAMIC_TABLE_RECORDS_REQUEST = "BULK_DELETE_DYNAMIC_TABLE_RECORDS_REQUEST";
export const BULK_DELETE_DYNAMIC_TABLE_RECORDS_SUCCESS = "BULK_DELETE_DYNAMIC_TABLE_RECORDS_SUCCESS";
export const BULK_DELETE_DYNAMIC_TABLE_RECORDS_FAILURE = "BULK_DELETE_DYNAMIC_TABLE_RECORDS_FAILURE";

export const GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_REQUEST = "GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_REQUEST";
export const GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_SUCCESS = "GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_SUCCESS";
export const GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_FAILURE = "GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_FAILURE";

export const GET_ENTITY_DYNAMIC_TABLES_REQUEST = "GET_ENTITY_DYNAMIC_TABLES_REQUEST";
export const GET_ENTITY_DYNAMIC_TABLES_SUCCESS = "GET_ENTITY_DYNAMIC_TABLES_SUCCESS";
export const GET_ENTITY_DYNAMIC_TABLES_FAILURE = "GET_ENTITY_DYNAMIC_TABLES_FAILURE";

export const GET_ASSIGN_PICKER_RECORDS_REQUEST = "GET_ASSIGN_PICKER_RECORDS_REQUEST";
export const GET_ASSIGN_PICKER_RECORDS_SUCCESS = "GET_ASSIGN_PICKER_RECORDS_SUCCESS";
export const GET_ASSIGN_PICKER_RECORDS_FAILURE = "GET_ASSIGN_PICKER_RECORDS_FAILURE";

export const GET_LIST_FOR_ASSIGN_PICKER_FILTER_REQUEST = "GET_LIST_FOR_ASSIGN_PICKER_FILTER_REQUEST";
export const GET_LIST_FOR_ASSIGN_PICKER_FILTER_SUCCESS = "GET_LIST_FOR_ASSIGN_PICKER_FILTER_SUCCESS";
export const GET_LIST_FOR_ASSIGN_PICKER_FILTER_FAILURE = "GET_LIST_FOR_ASSIGN_PICKER_FILTER_FAILURE";

export const BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST = "BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST";
export const BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS = "BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS";
export const BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE = "BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE";

export const BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST = "BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST";
export const BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS = "BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS";
export const BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE = "BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE";

export const CLEAR_DYNAMIC_TABLE_ASSIGN_RESPONSES = "CLEAR_DYNAMIC_TABLE_ASSIGN_RESPONSES";


export const GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_REQUEST = "GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_REQUEST";
export const GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_SUCCESS = "GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_SUCCESS";
export const GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_FAILURE = "GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_FAILURE";

export const VALIDATE_DYNAMIC_TABLE_IMPORT_REQUEST = "VALIDATE_DYNAMIC_TABLE_IMPORT_REQUEST";
export const VALIDATE_DYNAMIC_TABLE_IMPORT_SUCCESS = "VALIDATE_DYNAMIC_TABLE_IMPORT_SUCCESS";
export const VALIDATE_DYNAMIC_TABLE_IMPORT_FAILURE = "VALIDATE_DYNAMIC_TABLE_IMPORT_FAILURE";

export const CONFIRM_DYNAMIC_TABLE_IMPORT_REQUEST = "CONFIRM_DYNAMIC_TABLE_IMPORT_REQUEST";
export const CONFIRM_DYNAMIC_TABLE_IMPORT_SUCCESS = "CONFIRM_DYNAMIC_TABLE_IMPORT_SUCCESS";
export const CONFIRM_DYNAMIC_TABLE_IMPORT_FAILURE = "CONFIRM_DYNAMIC_TABLE_IMPORT_FAILURE";


export const CLEAR_DYNAMIC_TABLE_IMPORT_VALIDATION = "CLEAR_DYNAMIC_TABLE_IMPORT_VALIDATION";

export const RENDERABLE_FIELD_TYPES = [
    DYNAMIC_FIELD_TYPES.TEXT,
    DYNAMIC_FIELD_TYPES.MEMO,
    DYNAMIC_FIELD_TYPES.SELECT,
    DYNAMIC_FIELD_TYPES.NUMBER,
    DYNAMIC_FIELD_TYPES.DATE,
    DYNAMIC_FIELD_TYPES.CURRENCY,
    DYNAMIC_FIELD_TYPES.BOOLEAN
];

export const FIELD_TYPE_LABELS = {
    [DYNAMIC_FIELD_TYPES.TEXT]: "Text",
    [DYNAMIC_FIELD_TYPES.MEMO]: "Memo",
    [DYNAMIC_FIELD_TYPES.SELECT]: "Select",
    [DYNAMIC_FIELD_TYPES.NUMBER]: "Number",
    [DYNAMIC_FIELD_TYPES.DATE]: "Date",
    [DYNAMIC_FIELD_TYPES.DATE_TIME]: "Date Time",
    [DYNAMIC_FIELD_TYPES.CURRENCY]: "Currency",
    [DYNAMIC_FIELD_TYPES.BOOLEAN]: "Boolean",
    [DYNAMIC_FIELD_TYPES.COLOR]: "Color"
};
